const FrameAgreementDetailPage = () => {
  return <></>
}

export default FrameAgreementDetailPage
